module.exports = "<div class=\"filter-prop-tab\"><div class=\"control-group switch-to\">{{:: 'При срабатывании фильтра переключать на конфигурацию' | gettext}}:<label for=\"id_agent_configs\"></label><label for=\"id_agent_configs\" class=\"control-label\">{{:: 'агента' | gettext}}:</label><div class=\"controls\"><select id=\"id_agent_configs\" ng-model=\"filter.switch_to.agentConf\"><option value=\"\" selected=\"selected\">---------</option><option ng-repeat=\"conf in configs.agentConf\" value=\"{{conf.id}}\">{{conf.name}}</option></select></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/editor/tabs/incident-tab.component.html
// module id = 841
// module chunks = 0